// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3f8YV","icon":"SortAdornment_icon__hChFG","up":"SortAdornment_up__1bt5z","down":"SortAdornment_down__3HrZ5","active":"SortAdornment_active__2md55"};